export const MSFORMS_PREFIX = 'forms.office.com';
export const READ_MORE_URL =
  'https://github.com/zcmander/backstage-plugin-msforms';
